import React from 'react'
import './Topnav.css'
import closeimg from '../../../img/close.png'
import img_game from '../../../img/games.png'
import img_logo from '../../../img/logo.png'

export default function Topnav({ flag, setflag, gamecata }) {
  /* 是否显示 */
  const goClose = () => {
    setflag(false)
  }

  /* 跳转到分类页面 */
  // const goCate = (para) => {
  //   window.location = "/page/category?type=" + para;
  // };

  return (
    <div className={flag ? 'hearde-nav' : 'hearde-nav nav-remove'}>
      <div className="nav_box">
        <img className="close" onClick={goClose} src={closeimg} alt="" />

        <div className="nav-games">
          <img src={img_logo} alt="" />
          <h2>Category</h2>
        </div>

        <ul>
          {gamecata?.map(item => (
            <li key={item.type}>
              <a href={'/page/category?type=' + item.type} className="dis_a">
                <p>{item.name}</p>
                <img src={img_game} alt="" />
              </a>
            </li>
          ))}
          <li>
            <a href="/randomhow/index.html" className="dis_a">
              <p>RandomHow</p>
            </a>
          </li>
        </ul>
      </div>

      <div className="close_box" onClick={goClose}></div>
    </div>
  )
}
